// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as EventTracker from "../../../../../../library/event-tracker/react-ga/EventTracker.bs.js";
import * as ProgressModal from "../../../../../../library/components/generic-components/components/ProgressModal.bs.js";
import * as CountryContext from "../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as RaiseTicketPageV2 from "./RaiseTicketPageV2.bs.js";
import * as RaiseTicketDataMachine from "../../../app/repo/RaiseTicketDataMachine.bs.js";
import * as RaiseTicketSuccessPage from "../RaiseTicketSuccessPage.bs.js";
import * as CircularLoader$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/CircularLoader.bs.js";
import * as RaiseTicketStateMachine from "../RaiseTicketStateMachine.bs.js";
import * as RaiseTicketAssetsManager from "../../assets/RaiseTicketAssetsManager.bs.js";
import * as ToastSnackbarHook$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/hooks/toast-notification/ToastSnackbarHook.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";

RaiseTicketAssetsManager.importCss(undefined);

function RaiseTicketCmpV2(Props) {
  var crn = Props.crn;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = React.useReducer(RaiseTicketStateMachine.reducer, RaiseTicketStateMachine.intitial_state);
  var dispatch = match$1[1];
  var state = match$1[0];
  var match$2 = ToastSnackbarHook$Catalyst.useSnackbar(5000, undefined, undefined);
  var openSnackbar = match$2[1];
  React.useEffect((function () {
          RaiseTicketDataMachine.fetchTicketInfo(Belt_Option.getWithDefault(crn, ""), country, (function (ticket_info) {
                  return Curry._1(dispatch, {
                              TAG: /* SetTicketInfo */0,
                              ticket_info: {
                                TAG: /* Live */1,
                                _0: ticket_info
                              }
                            });
                }), (function (error) {
                  return Curry._1(dispatch, {
                              TAG: /* SetTicketInfo */0,
                              ticket_info: {
                                TAG: /* Error */2,
                                _0: error
                              }
                            });
                }));
          
        }), []);
  React.useEffect((function () {
          var message = state.snackbar_message;
          if (message !== undefined) {
            Curry._1(openSnackbar, message);
            Curry._1(dispatch, /* ClearSnackbar */0);
          }
          
        }), [state.snackbar_message]);
  var match$3 = state.create_ticket_response;
  var tmp;
  tmp = typeof match$3 === "number" || match$3.TAG !== /* Loading */0 ? null : React.createElement(ProgressModal.make, {
          isOpen: true
        });
  var ticket_response = state.create_ticket_response;
  var tmp$1;
  var exit = 0;
  if (typeof ticket_response === "number" || ticket_response.TAG !== /* Live */1) {
    exit = 1;
  } else {
    EventTracker.publishEvent({
          category: "Raise Ticket V2",
          action: "Raise Ticket Success",
          label: "Random",
          value: undefined,
          nonInteraction: undefined
        });
    tmp$1 = React.createElement(RaiseTicketSuccessPage.make, {
          ticket_response: ticket_response._0
        });
  }
  if (exit === 1) {
    var error = state.ticket_info;
    if (typeof error === "number") {
      tmp$1 = React.createElement(CircularLoader$Catalyst.make, {});
    } else {
      switch (error.TAG | 0) {
        case /* Loading */0 :
            tmp$1 = React.createElement(CircularLoader$Catalyst.make, {});
            break;
        case /* Live */1 :
            tmp$1 = React.createElement(RaiseTicketPageV2.make, {
                  state: state,
                  dispatch: dispatch,
                  country: country
                });
            break;
        case /* Error */2 :
            tmp$1 = React.createElement(ErrorDisplayComponent$Catalyst.make, {
                  error: error._0
                });
            break;
        
      }
    }
  }
  return React.createElement("div", {
              className: "c-raise-ticket-home-v2"
            }, match$2[0], tmp, tmp$1);
}

var make = RaiseTicketCmpV2;

export {
  make ,
  
}
/*  Not a pure module */
